import { CaretUpOutlined } from "@ant-design/icons"
import { Flex } from "antd"
import { spaces } from "../../utils/styles"
import { MoneyLabel } from "../atoms/formatters/MoneyLabel"

export const InflowLabel = ({ value, currency = "USD" }) => {
  return (
    <Flex style={{ justifyContent: "center", gap: spaces.space1, color: "green" }}>
      <CaretUpOutlined style={{ color: "green" }} />
      <MoneyLabel value={value} currency={currency} />
    </Flex>
  )
}
